import React, { MouseEventHandler, KeyboardEventHandler } from 'react';

import { ArrowLeft } from '@johnlewispartnership/wtr-ingredients/foundations/icons';

import styles from './SearchNavigateBack.scss';

interface SearchNavigateBackProps {
  onClick: MouseEventHandler<HTMLDivElement>;
  onKeyDown: KeyboardEventHandler<HTMLDivElement>;
}

const SearchNavigateBack: React.FC<SearchNavigateBackProps> = ({ onClick, onKeyDown }) => (
  <div
    data-testid="search-item-navigate-back"
    id="search-navigate-back"
    onClick={onClick}
    onKeyDown={onKeyDown}
    className={styles.navigateItem}
    role="button"
    tabIndex={-1}
  >
    <ArrowLeft className={styles.arrowLeft} size="medium" />
    <span>Back to results</span>
  </div>
);

export default SearchNavigateBack;
